import React from 'react';

import ProfileShow from 'components/user/profile/show';
import ProfileSecurity from 'components/user/profile/security';
import ProfileSessionInfo from 'components/user/profile/session_info';
import PlanShow from 'components/space/plan';
import CloudStorage from 'components/user/profile/storage/cloud_storage';
import BreadcrumbContainer from 'components/breadcrumb_container';
import Container from 'components/layout/container';
import TabsContainer from 'components/tabs_container';
import featureFlags from 'utils/feature_flags';
import { FormattedMessage } from 'react-intl';
import { BreadCrumbTypography } from 'components/styles_components/typography';

const Profile = () => {
  return (
    <Container>
      <BreadcrumbContainer>
        <BreadCrumbTypography>
          <FormattedMessage id="breadcrumb.usersprofile" />
        </BreadCrumbTypography>
      </BreadcrumbContainer>

      <TabsContainer
        tabs={[
          { label: <FormattedMessage id="user.profile.data" />, visible: true },
          { label: <FormattedMessage id="user.profile.security" />, visible: true },
          { label: <FormattedMessage id="user.profile.sessions" />, visible: true },
          { label: <FormattedMessage id="user.profile.cloud_storage" />, visible: featureFlags.STORAGE },
        ]}
        content={[
          <ProfileShow key="profile-show-content" />,
          <ProfileSecurity key="profile-security-content" />,
          <ProfileSessionInfo key="profile-session-info-content" />,
          featureFlags.STORAGE && <CloudStorage key="cloud-storage-content" />,
        ].filter(item => item !== false)}
      />
    </Container>
  );
};

export default Profile;
